import Tooltip from "@/v2-ui/tooltip"
import cn from "@/v2-ui/utils/utils.cn"
import {
  describeNotChecked,
  NOT_CHECKED_NOTE,
  type CheckedBy,
} from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.checkedBy.utils"
import { ROW_NOTE_CLASS } from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.compose.constants"

export type LicenseFeatureGroupCheckedByMarkProps = {
  checkedBy: CheckedBy
}

// Who checks a code, written beside its name where a code is offered or
// listed one by one. "checked by the Placepoint MCP server" for a server
// check, the explanation on hover; "not checked yet" when nothing checks
// it, with why that is and what the grant does (nothing, today). Both in
// the same quiet note style: neither is a fault, both are facts. Nothing
// for a capability or map content: those lists say so already.
function LicenseFeatureGroupCheckedByMark(
  props: LicenseFeatureGroupCheckedByMarkProps,
) {
  const { checkedBy } = props
  if (checkedBy.kind === "console" || checkedBy.kind === "content") return null

  if (checkedBy.kind === "server") {
    const text = `checked by ${checkedBy.names}`
    return (
      <Tooltip>
        <Tooltip.Trigger asChild>
          <span className={cn(ROW_NOTE_CLASS, "cursor-help")} title={text}>
            {text}
          </span>
        </Tooltip.Trigger>
        <Tooltip.Content side="top" className="max-w-[340px]">
          {checkedBy.how ?? text}
        </Tooltip.Content>
      </Tooltip>
    )
  }

  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <span className={cn(ROW_NOTE_CLASS, "cursor-help")}>
          {NOT_CHECKED_NOTE}
        </span>
      </Tooltip.Trigger>
      <Tooltip.Content side="top" className="max-w-[340px]">
        Checked by {describeNotChecked()}
      </Tooltip.Content>
    </Tooltip>
  )
}

export default LicenseFeatureGroupCheckedByMark
